(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-article-highlights"] && !Shopify.designMode) return;
  try {
    
  class CustomArticleHighlightsSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.custom-article-highlights__track');

      if (!this.track) {
        return;
      }

      this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
      this.desktopQuery = window.matchMedia('(min-width: 1024px)');
      this.desktopQuery.addEventListener('change', this.handleBreakpointChange);
      this.handleBreakpointChange(this.desktopQuery);

      // Cell heights measured at init can be wrong because slide images are
      // loading='lazy': window's 'load' event only waits for non-lazy
      // resources, so a lazy image can still finish loading well after it —
      // re-measure whenever one actually settles, whatever order that happens in.
      this.resizeOnImageLoad = this.resizeOnImageLoad.bind(this);
      this.track.querySelectorAll('img').forEach(
        function (img) {
          if (img.complete) {
            return;
          }
          img.addEventListener('load', this.resizeOnImageLoad, { once: true });
          img.addEventListener('error', this.resizeOnImageLoad, { once: true });
        }.bind(this)
      );
    }

    resizeOnImageLoad() {
      if (this.flickity) {
        this.flickity.resize();
      }
    }

    handleBreakpointChange(query) {
      if (query.matches) {
        this.destroyFlickity();
      } else {
        this.waitForFlickity(0);
      }
    }

    waitForFlickity(attempts) {
      if (typeof Flickity !== 'undefined') {
        this.initFlickity();
        return;
      }

      // Flickity ships in vendor-scripts-v11.js, loaded separately from this
      // section's own script: retry briefly instead of assuming load order.
      if (attempts < 40) {
        setTimeout(this.waitForFlickity.bind(this, attempts + 1), 50);
      }
    }

    initFlickity() {
      if (this.flickity) {
        return;
      }

      var count = parseInt(this.track.dataset.count, 10) || 0;

      this.flickity = new Flickity(this.track, {
        cellAlign: 'center',
        contain: true,
        pageDots: false,
        prevNextButtons: true,
        wrapAround: count > 1,
        adaptiveHeight: false,
      });
    }

    destroyFlickity() {
      if (this.flickity && typeof this.flickity.destroy === 'function') {
        this.flickity.destroy();
      }
      this.flickity = null;
    }

    disconnectedCallback() {
      if (this.desktopQuery) {
        this.desktopQuery.removeEventListener('change', this.handleBreakpointChange);
      }
      this.destroyFlickity();
    }
  }

  if (!customElements.get('custom-article-highlights-slider')) {
    customElements.define('custom-article-highlights-slider', CustomArticleHighlightsSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-category-slider"] && !Shopify.designMode) return;
  try {
    
  class CustomCategorySlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.custom-category-slider__track');

      if (!this.track) {
        return;
      }

      this.waitForFlickity(0);
    }

    waitForFlickity(attempts) {
      if (typeof Flickity !== 'undefined') {
        this.init();
        return;
      }

      // Flickity ships in vendor-scripts-v11.js, loaded separately from this
      // section's own script: retry briefly instead of assuming load order.
      if (attempts < 40) {
        setTimeout(this.waitForFlickity.bind(this, attempts + 1), 50);
      }
    }

    init() {
      var count = parseInt(this.track.dataset.count, 10) || 0;

      this.flickity = new Flickity(this.track, {
        cellAlign: 'left',
        contain: false,
        pageDots: true,
        prevNextButtons: true,
        wrapAround: count > 3,
        adaptiveHeight: false,
      });

      // Cell heights measured at init can be wrong because some card images
      // are loading='lazy' (only the first sections on the page get eager
      // cards, see card_loading above): window's 'load' event only waits for
      // non-lazy resources, so a lazy image can still finish loading well
      // after it — re-measure whenever one actually settles.
      this.resizeOnImageLoad = this.resizeOnImageLoad.bind(this);
      this.track.querySelectorAll('img').forEach(
        function (img) {
          if (img.complete) {
            return;
          }
          img.addEventListener('load', this.resizeOnImageLoad, { once: true });
          img.addEventListener('error', this.resizeOnImageLoad, { once: true });
        }.bind(this)
      );
    }

    resizeOnImageLoad() {
      if (this.flickity) {
        this.flickity.resize();
      }
    }

    disconnectedCallback() {
      if (this.flickity && typeof this.flickity.destroy === 'function') {
        this.flickity.destroy();
      }
    }
  }

  if (!customElements.get('custom-category-slider')) {
    customElements.define('custom-category-slider', CustomCategorySlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-highlights-ads"] && !Shopify.designMode) return;
  try {
    
  class CustomProductHighlightsAdsSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.custom-product-highlights-ads__track');

      if (!this.track) {
        return;
      }

      this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
      this.desktopQuery = window.matchMedia('(min-width: 1024px)');
      this.desktopQuery.addEventListener('change', this.handleBreakpointChange);
      this.handleBreakpointChange(this.desktopQuery);

      // Cell heights measured at init can be wrong because slide images are
      // loading='lazy': window's 'load' event only waits for non-lazy
      // resources, so a lazy image can still finish loading well after it —
      // re-measure whenever one actually settles, whatever order that happens in.
      this.resizeOnImageLoad = this.resizeOnImageLoad.bind(this);
      this.track.querySelectorAll('img').forEach(
        function (img) {
          if (img.complete) {
            return;
          }
          img.addEventListener('load', this.resizeOnImageLoad, { once: true });
          img.addEventListener('error', this.resizeOnImageLoad, { once: true });
        }.bind(this)
      );
    }

    resizeOnImageLoad() {
      if (this.flickity) {
        this.flickity.resize();
      }
    }

    handleBreakpointChange(query) {
      if (query.matches) {
        this.destroyFlickity();
      } else {
        this.waitForFlickity(0);
      }
    }

    waitForFlickity(attempts) {
      if (typeof Flickity !== 'undefined') {
        this.initFlickity();
        return;
      }

      // Flickity ships in vendor-scripts-v11.js, loaded separately from this
      // section's own script: retry briefly instead of assuming load order.
      if (attempts < 40) {
        setTimeout(this.waitForFlickity.bind(this, attempts + 1), 50);
      }
    }

    initFlickity() {
      if (this.flickity) {
        return;
      }

      var count = parseInt(this.track.dataset.count, 10) || 0;

      this.flickity = new Flickity(this.track, {
        cellAlign: 'left',
        contain: false,
        pageDots: false,
        prevNextButtons: true,
        wrapAround: count > 3,
        adaptiveHeight: false,
      });
    }

    destroyFlickity() {
      if (this.flickity && typeof this.flickity.destroy === 'function') {
        this.flickity.destroy();
      }
      this.flickity = null;
    }

    disconnectedCallback() {
      if (this.desktopQuery) {
        this.desktopQuery.removeEventListener('change', this.handleBreakpointChange);
      }
      this.destroyFlickity();
    }
  }

  if (!customElements.get('custom-product-highlights-ads-slider')) {
    customElements.define('custom-product-highlights-ads-slider', CustomProductHighlightsAdsSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-highlights"] && !Shopify.designMode) return;
  try {
    
  class CustomProductHighlightsSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.custom-product-highlights__track');

      if (!this.track) {
        return;
      }

      this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
      this.desktopQuery = window.matchMedia('(min-width: 1024px)');
      this.desktopQuery.addEventListener('change', this.handleBreakpointChange);
      this.handleBreakpointChange(this.desktopQuery);

      // Cell heights measured at init can be wrong because slide images are
      // loading='lazy': window's 'load' event only waits for non-lazy
      // resources, so a lazy image can still finish loading well after it —
      // re-measure whenever one actually settles, whatever order that happens in.
      this.resizeOnImageLoad = this.resizeOnImageLoad.bind(this);
      this.track.querySelectorAll('img').forEach(
        function (img) {
          if (img.complete) {
            return;
          }
          img.addEventListener('load', this.resizeOnImageLoad, { once: true });
          img.addEventListener('error', this.resizeOnImageLoad, { once: true });
        }.bind(this)
      );
    }

    resizeOnImageLoad() {
      if (this.flickity) {
        this.flickity.resize();
      }
    }

    handleBreakpointChange(query) {
      if (query.matches) {
        this.destroyFlickity();
      } else {
        this.waitForFlickity(0);
      }
    }

    waitForFlickity(attempts) {
      if (typeof Flickity !== 'undefined') {
        this.initFlickity();
        return;
      }

      // Flickity ships in vendor-scripts-v11.js, loaded separately from this
      // section's own script: retry briefly instead of assuming load order.
      if (attempts < 40) {
        setTimeout(this.waitForFlickity.bind(this, attempts + 1), 50);
      }
    }

    initFlickity() {
      if (this.flickity) {
        return;
      }

      var count = parseInt(this.track.dataset.count, 10) || 0;

      this.flickity = new Flickity(this.track, {
        cellAlign: 'left',
        contain: false,
        pageDots: false,
        prevNextButtons: true,
        wrapAround: count > 3,
        adaptiveHeight: false,
      });
    }

    destroyFlickity() {
      if (this.flickity && typeof this.flickity.destroy === 'function') {
        this.flickity.destroy();
      }
      this.flickity = null;
    }

    disconnectedCallback() {
      if (this.desktopQuery) {
        this.desktopQuery.removeEventListener('change', this.handleBreakpointChange);
      }
      this.destroyFlickity();
    }
  }

  if (!customElements.get('custom-product-highlights-slider')) {
    customElements.define('custom-product-highlights-slider', CustomProductHighlightsSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-shoppable-hero-split"] && !Shopify.designMode) return;
  try {
    
  class CustomShoppableHeroSplit extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener(
          'scroll',
          () => {
            this.querySelectorAll('kit-popover:popover-open').forEach((p) => p.hidePopover());
          },
          { passive: true, signal }
        );
      }

      if (!Shopify.designMode) return;

      document.addEventListener(
        'shopify:section:load',
        (event) => {
          if (event.target.contains(this)) {
            this.initQuickShop();
          }
        },
        { signal }
      );

      this.addEventListener(
        'shopify:block:select',
        (event) => {
          this.initQuickShop();
          const btn = event.target.querySelector('button');
          if (btn) btn.click();
        },
        { signal }
      );

      this.addEventListener(
        'shopify:block:deselect',
        (event) => {
          const popover = event.target.querySelector('kit-popover');
          if (popover) popover.hidePopover?.();
        },
        { signal }
      );
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach((link) => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        link.addEventListener(
          'click',
          (event) => {
            if (theme.config.bpSmall) {
              event.stopImmediatePropagation();
              return;
            }
            const popover = event.target.closest('kit-popover');
            if (popover) popover.hidePopover?.();
          },
          true
        );

        var hotspot = link.closest('.custom-shoppable-hero-split__hotspot');
        if (!hotspot) return;

        var preloadOnce = function () {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  if (!customElements.get('custom-shoppable-hero-split')) {
    customElements.define('custom-shoppable-hero-split', CustomShoppableHeroSplit);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class CustomShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener(
          'scroll',
          () => {
            this.querySelectorAll('kit-popover:popover-open').forEach((p) => p.hidePopover());
          },
          { passive: true, signal }
        );
      }

      if (!Shopify.designMode) return;

      document.addEventListener(
        'shopify:section:load',
        (event) => {
          if (event.target.contains(this)) {
            this.initQuickShop();
          }
        },
        { signal }
      );

      this.addEventListener(
        'shopify:block:select',
        (event) => {
          this.initQuickShop();
          const btn = event.target.querySelector('button');
          if (btn) btn.click();
        },
        { signal }
      );

      this.addEventListener(
        'shopify:block:deselect',
        (event) => {
          const popover = event.target.querySelector('kit-popover');
          if (popover) popover.hidePopover?.();
        },
        { signal }
      );
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach((link) => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        link.addEventListener(
          'click',
          (event) => {
            if (theme.config.bpSmall) {
              event.stopImmediatePropagation();
              return;
            }
            const popover = event.target.closest('kit-popover');
            if (popover) popover.hidePopover?.();
          },
          true
        );

        var hotspot = link.closest('.custom-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function () {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  if (!customElements.get('custom-shoppable-hero')) {
    customElements.define('custom-shoppable-hero', CustomShoppableHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
